import { Link } from 'react-router'

export function NotFound() {
  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      {/* Drawn, for the same reason as everywhere else: the Pi has no emoji
          font and a missing glyph is a rectangle. */}
      <svg
        viewBox="0 0 24 24"
        className="text-ink-muted size-(--text-hero)"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        aria-hidden="true"
      >
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="M15.5 15.5 21 21" />
      </svg>
      <h1 className="text-(length:--text-title)">There&rsquo;s nothing here</h1>
      <p className="text-ink-muted">That page doesn&rsquo;t exist. Let&rsquo;s go and play.</p>
      <Link to="/" className="text-primary underline">
        Back to the games
      </Link>
    </div>
  )
}
